(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ja-scenes')) {
  customElements.define('ja-scenes', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.photos = [...this.querySelectorAll('[data-scene]')];
      this.dialog = this.querySelector('dialog');
      this.full = this.querySelector('.ja-scenes__full');
      this.count = this.querySelector('[data-count]');
      this.photos.forEach((button, index) => button.addEventListener('click', () => {
        this.show(index);
        this.dialog.showModal();
      }));
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }
    show(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      const button = this.photos[this.index];
      this.full.src = button.dataset.full;
      this.full.alt = button.querySelector('img').alt;
      this.count.textContent = `${this.index + 1} / ${this.photos.length}`;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ja101-program"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ja101-sample-order')) {
  customElements.define('ja101-sample-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const quantity = this.querySelector('[name="quantity"]');
      if (!quantity) return;
      this.querySelector('[data-minus]').addEventListener('click', () => quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) - 1));
      this.querySelector('[data-plus]').addEventListener('click', () => quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) + 1));
      this.querySelectorAll('[name="id"]').forEach(radio => radio.addEventListener('change', () => {
        this.querySelector('[data-sample-price]').textContent = radio.dataset.price;
      }));
    }
  });
}
const quoteTarget = document.getElementById('JA101QuoteQuantities');
if (quoteTarget && !quoteTarget.value) {
  try { quoteTarget.value = sessionStorage.getItem('ja101VolumeQuantities') || ''; } catch (error) {}
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ja101-split-product"]) return;
  try {
    
if(!customElements.get('ja101-split')) customElements.define('ja101-split',class extends HTMLElement{
 connectedCallback(){
 if(this.initialized)return;this.initialized=true;
 const root=this;const inputs=[...root.querySelectorAll('.ja-qty')],qtyEl=root.querySelector('#ja-total-qty'),unitEl=root.querySelector('#ja-unit-price'),totalEl=root.querySelector('#ja-order-total'),button=root.querySelector('#ja-add-all'),message=root.querySelector('#ja-matrix-message');const money=n=>'$'+n.toFixed(2);const totalQty=()=>inputs.reduce((sum,i)=>sum+(parseInt(i.value)||0),0);const volumeDetails=()=>inputs.filter(i=>(parseInt(i.value)||0)>0).map(i=>i.getAttribute('aria-label').replace(' quantity','')+' — '+(parseInt(i.value)||0)).join('\n');function update(){let qty=0,total=0;inputs.forEach(i=>{const n=Math.max(0,parseInt(i.value)||0),unit=n>=48?16:n>=12?18:20;qty+=n;total+=n*unit});qtyEl.textContent=qty;unitEl.textContent=money(qty?total/qty:20);totalEl.textContent=money(total);button.disabled=qty===0;if(qty>=864){button.textContent='Request a volume quote';message.innerHTML='<strong>You\'ve reached volume ordering</strong><br>Orders of 864 T-shirts or more are handled through our Volume Program, with custom pricing and coordinated fulfillment. Contact us to continue with a tailored quote.';}else{button.textContent='Add all to cart';message.textContent='';}root.querySelectorAll('[data-row]').forEach(row=>{let n=0;row.querySelectorAll('.ja-qty').forEach(i=>n+=parseInt(i.value)||0);row.querySelector('.ja-row-total').textContent=n});}inputs.forEach(i=>i.addEventListener('input',update));button.addEventListener('click',async()=>{const qty=totalQty();if(qty>=864){sessionStorage.setItem('ja101VolumeQuantities',volumeDetails());location.href='/pages/ja-101#volume-quote';return;}const items=inputs.map(i=>({id:Number(i.dataset.id),quantity:parseInt(i.value)||0})).filter(i=>i.quantity>0);if(!items.length)return;button.disabled=true;button.textContent='Adding…';message.textContent='';try{const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});if(!res.ok)throw new Error();location.href='/cart';}catch(e){message.textContent='We could not add those quantities. Please review availability and try again.';button.disabled=false;button.textContent='Add all to cart';}});update();
 const selectColour=colour=>{this.dataset.colour=colour;this.querySelectorAll('[data-gallery]').forEach(g=>g.hidden=g.dataset.gallery!==colour);this.querySelector('[data-selected-colour]').textContent=colour;this.querySelectorAll('input[type=radio]').forEach(r=>r.checked=r.value===colour);};
 this.querySelectorAll('input[type=radio]').forEach(r=>r.addEventListener('change',()=>selectColour(r.value)));
 this.onBlockSelect=e=>{const photo=e.target.closest('[data-photo-colour]');if(photo&&this.contains(photo))selectColour(photo.dataset.photoColour);};document.addEventListener('shopify:block:select',this.onBlockSelect);
 const dialog=this.querySelector('dialog'),fullImage=dialog.querySelector('img');
 this.querySelectorAll('[data-full]').forEach(b=>b.addEventListener('click',()=>{fullImage.src=b.dataset.full;fullImage.alt=b.querySelector('img').alt;dialog.showModal();}));
 dialog.querySelector('[data-close-image]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
}
 disconnectedCallback(){document.removeEventListener('shopify:block:select',this.onBlockSelect);}
});

  } catch(e) { console.error(e); }
})();
})();
